var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG2CrowdVectorLogo2022(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF492C;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.4,321.4c0,138.1-111.9,250-250,250c-138.1,0-250-111.9-250-250c0-138.1,111.9-250,250-250 C459.5,71.4,571.4,183.4,571.4,321.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.6,280.6H365v-3c0-11,2.2-20.1,6.6-27.2c4.4-7.2,12-13.5,23-19.1l5-2.5c8.9-4.5,11.2-8.4,11.2-13 c0-5.5-4.8-9.5-12.5-9.5c-9.2,0-16.1,4.8-20.9,14.5L365,208.4c2.7-5.8,7.1-10.4,12.9-14.1c5.9-3.7,12.4-5.5,19.5-5.5 c8.9,0,16.6,2.3,22.9,7.1c6.5,4.8,9.7,11.4,9.7,19.7c0,13.3-7.5,21.4-21.5,28.6l-7.9,4c-8.4,4.2-12.5,8-13.7,14.7h42.7V280.6z  M423.9,301h-70.7l-35.3,61.2h70.7l35.4,61.2l35.3-61.2L423.9,301z M324,403.1c-45,0-81.6-36.6-81.6-81.6c0-45,36.6-81.6,81.6-81.6 l28-58.5c-9.1-1.8-18.4-2.7-28-2.7c-78.9,0-142.9,64-142.9,142.8c0,78.9,63.9,142.9,142.9,142.9c31.4,0,60.5-10.2,84.1-27.4 l-31-53.6C362.9,395.6,344.3,403.1,324,403.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2CrowdVectorLogo2022);
export default __webpack_public_path__ + "static/media/g2-crowd-vector-logo-2022.7e421c1ae6b487e08f6326062f22991a.svg";
export { ForwardRef as ReactComponent };